export const MULTI_OFFER_RESULTS = {
  DEFAULT: 'default',
  DEFAULT_HAS_EXPIRED: 'has-expired',
  DEFAULT_ALL_EXPIRED: 'all-expired',
  PENDING: 'pending',
};

export const OFFER_DETAILS = {
  /**
   * Accepted offer (i.e. with non-zero valuation).
   */
  DEFAULT: 'default',
  /**
   * Expired accepted offer.
   */
  EXPIRED: 'expired',
  /**
   * Declined offer with an estimate.
   */
  ESTIMATED: 'estimated',
  /**
   * Expired declined offer with an estimate.
   */
  ESTIMATED_EXPIRED: 'estimated_expired',
  /**
   * Declined offer with NO estimate.
   */
  NO_ESTIMATE: 'no_estimate',
  /**
   * No partners prequalified.
   */
  NO_PARTNERS: 'no_partners',
  /**
   * No offer at all (due to API error or missing data).
   */
  NO_OFFER: 'no_offer',
};
